import { useToast, type ToastKind } from '../state/toast';

const KIND_BG: Record<ToastKind, string> = {
  info: 'rgba(59,130,246,0.95)',
  success: 'rgba(22,163,74,0.95)',
  warn: 'rgba(245,158,11,0.95)',
  error: 'rgba(220,38,38,0.95)',
};
const KIND_FG: Record<ToastKind, string> = {
  info: '#fff',
  success: '#fff',
  warn: '#1a1a1a',
  error: '#fff',
};

export default function ToastViewport() {
  const items = useToast((s) => s.items);
  const dismiss = useToast((s) => s.dismiss);
  if (items.length === 0) return null;
  return (
    <div
      role="region"
      aria-label="通知"
      style={{
        position: 'fixed',
        bottom: 96,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        zIndex: 60,
        pointerEvents: 'none',
      }}
    >
      {items.map((it) => (
        <div
          key={it.id}
          role={it.kind === 'error' ? 'alert' : 'status'}
          onClick={() => dismiss(it.id)}
          style={{
            padding: '10px 16px',
            borderRadius: 10,
            background: KIND_BG[it.kind],
            color: KIND_FG[it.kind],
            fontSize: 13,
            fontWeight: 500,
            boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
            maxWidth: 360,
            pointerEvents: 'auto',
            cursor: 'pointer',
          }}
        >
          {it.text}
        </div>
      ))}
    </div>
  );
}
